<template>
  <section id="page-charts">
    <b-card v-show="!reportMode || reportMode == 'editable'" class="d-print-none filters">
      <b-row>
        <b-col sm="3">
          <b-input-group label="Sito">
            <b-select v-if="sites.length > 0 && sites.length > 1" class="site-select" v-model="site" :options="sites"></b-select>
            <p v-else-if="sites.length > 0 && sites.length <= 1">{{ sites[0].text }}</p>
          </b-input-group>
        </b-col>
        <b-col>
          <b-btn class="float-right" @click="print()" variant="primary"><font-awesome-icon icon="print" /></b-btn>
          <b-button-toolbar>
            <b-input-group size="sm" class="mx-1" prepend="Periodo">
              <div class="form-control">
                <div>
                  <vue-monthly-picker v-model="fromMonth"
                            :monthLabels="monthLabels"
                            :max="maxDate"
                            dateFormat="MM/YYYY" />
                  -
                  <vue-monthly-picker v-model="toMonth"
                            :monthLabels="monthLabels"
                            :max="maxDate"
                            dateFormat="MM/YYYY" />
                </div>
              </div>
            </b-input-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
    </b-card>

    <template v-if="!loading">
      <b-card id="sankey"
              class="diagnosi-vector-wrapper"
      >

        <b-row v-if="! tep">
          <b-col>
            <b-progress-bar :value="100" :max="100" variant="success" striped :animated="true">
              Caricamento dati in corso
            </b-progress-bar>
          </b-col>
        </b-row>
        <sankey
          v-else
          ref="sankeyReference"
          :site="site" :tep="tep" :reportMode="reportMode" :sankeyParameters="sankeyParameters" />
      </b-card>

      <b-card v-if="!reportMode"
        v-observe-visibility="(isVisible, entry) => visibilityChanged(isVisible, entry, 'vettori-energetici')"
        class="diagnosi-vector-wrapper"
        title="Vettori energetici (tep)"
        id="vettori-energetici">
          <vectors
            v-if="visibility['vettori-energetici']"
            :tep="tep" :params="params" />
      </b-card>
      <div v-if="!reportMode">
        <div v-for="vector in vectors" :key="vector">
          <b-card title="Modello Energetico"
                  class="diagnosi-vector-wrapper"
                  v-observe-visibility="(isVisible, entry) => visibilityChanged(isVisible, entry, `${vector}-summary`)"
                  :sub-title="vectorName(vector)"
                  :id="getModelloLink(vector)">
            <SummaryTable
              v-if="visibility[`${vector}-summary`]"
              :tep="tep" :vector="vector" :params="params"/>
          </b-card>

            <!-- Canali root -->
            <b-card :id="channel.name|slugify"
                    :title="getTitle(channel)"
                    v-for="channel in rootChannelsByVector(vector)"
                    class="diagnosi-vector-wrapper"
                    v-observe-visibility="{ intersection: {rootMargin:  '200px 200px 200px 200px',
      threshold: 0.8, },once: true, throttle: 800, callback:(isVisible, entry) => visibilityChanged(isVisible, entry, `${vector}-${channel.name}`)}"
                    :key="`${vector}-canali-root-${channel.code}`"
            >
                <!-- v-if="visibility[`${vector}-${channel.name}`]" -->
              <charts
                :vector="vector" :params="params" :parent="channel.code" :channels="channels" :load="visibility[`${vector}-${channel.name}`]"/>
            </b-card>

            <!-- Allocazione vettore -->
            <b-card
              class="diagnosi-vector-wrapper"
              v-observe-visibility="{once: true, intersection: {rootMargin:  '200px 200px 200px 200px',
      threshold: 0.8, }, throttle: 800, callback: (isVisible, entry) => visibilityChanged(isVisible, entry, `${vector}-allocazione`)}"
              :title="'Allocazione ' + vectorName(vector)"
              :id="getAllocazioneLink(vector)">

                <!-- v-if="visibility[`${vector}-allocazione`]" -->
              <charts
                class="diagnosi-vector-wrapper"
                :params="params" :vector="vector" :recursive="false" :load="visibility[`${vector}-allocazione`]"/>
            </b-card>

            <div v-for="c in categoriesForVector(vector)" :key="`${vector}-category-${c.categoryId}`">
              <b-card
                class="diagnosi-vector-wrapper"
                v-observe-visibility="{ intersection: {rootMargin:  '200px 200px 200px 200px',
      threshold: 0.8, },once: true, throttle: 800, callback:(isVisible, entry) => visibilityChanged(isVisible, entry, `${vector}-category-${c.categoryId}`)}"
                :id="c.category + '-' + c.vector | slugify" :title="'Allocazione ' + c.category"
                      :sub-title="vectorName(vector)">

                  <!-- v-if="visibility[`${vector}-category-${c.categoryId}`]" -->
                <charts
                  :channels="channels" :params="params" :vector="vector" :categoryId="c.categoryId" :load="visibility[`${vector}-category-${c.categoryId}`]"/>
              </b-card>
              <b-card
                class="diagnosi-vector-wrapper"
                v-for="channel in channelsByCategoryAndVector(vector, c.categoryId)"
                :id="channel.name|slugify" :title="getTitle(channel)"
                :key="`${vector}-diagnosi-vector-${c.categoryId}-${channel.code}`"
                v-observe-visibility="{intersection: {rootMargin:  '200px 200px 200px 200px',
      threshold: 0.8, },once: true, throttle: 800, callback:(isVisible, entry) => visibilityChanged(isVisible, entry, `${vector}-category-${c.categoryId}-${channel.code}`)}"
                >
                  <!-- v-if="visibility[`${vector}-category-${c.categoryId}-${channel.code}`]" -->
                <charts
                  :recursive="true" :vector="vector" :params="params" :parent="channel.code" :channels="channels" :load="visibility[`${vector}-category-${c.categoryId}-${channel.code}`]"/>
              </b-card>
            </div>
        </div>
      </div>
      <scroll-top />
    </template>
  </section>
</template>

<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import Sankey from './Sankey';
import Charts from './Charts';
import Vectors from './Vectors';
import SummaryTable from './SummaryTable';
import ScrollTop from '../Layout/ScrollTop';
import {mapMutations} from "vuex";
var moment = require('moment');

export default {
  name: 'DLgs',

  components: {
    Sankey,
    Charts,
    Vectors,
    SummaryTable,
    VueMonthlyPicker,
    ScrollTop
  },
  props:{
    reportMode:{
      required:false,
      default:false
    },
    sankeyParameters:{
      required:false
    },
    minMonth: {
      required: false
    },
    maxMonth: {
      required:false
    }
  },

  data() {
    return {
      params: {},
      fromMonth: moment().add(-12, 'months'),
      toMonth: moment().add(-1, 'months'),
      site: null,
      tep: null,
      tepMonthly: null,
      channels: [],
      userSites:[],
      vectors: [],
      categories: [],
      visibility: {},
      maxDate: moment().add(-1, 'months'),
      loading: true
    }
  },
  created() {
    let reportParameters = this.sankeyParameters;
    if(this.sites && this.sites.length > 0) {
        this.site = this.sites[0].value
    }

    this.$store.dispatch("sites/list").then(sites => {
      this.userSites = sites
      this.site = sites[0].guid
      if(reportParameters && reportParameters.site){
        this.site = reportParameters.site;
      }

      //this.refresh()
    })
  },
  methods: {
    ...mapMutations({
      startLoading: "loading",
      stopLoading: "stopLoading"
    }),

    visibilityChanged(isVisible, entry, key) {
      if (isVisible) {
        this.$set(this.visibility, key, isVisible);
      }
    },

    channelsByCategoryAndVector(vector, categoryId) {
      return _.filter(
        this.channels, c => c.category == categoryId && c.vector === vector
        && c.data_model_id == 1);
    },
    rootChannelsByVector(vector) {
      return _.filter(this.channels, c => {
        return c.vector == vector && c.parent_code == null && c.data_model_id == 1
      })
    },
    channelsByVector(vector) {
      return _.filter(this.channels, c => {
        return c.vector == vector && c.parent_code != null && c.data_model_id == 1
      })
    },
    refresh() {
      if(! this.site)
        return

      this.loading = true;
      this.startLoading();

      if(this.sankeyParameters) {
        this.params = {
          siteGuid: this.site,
          fromMonth: this.sankeyParameters.fromMonth,
          toMonth: this.sankeyParameters.toMonth
        }
      } else {
        this.params = {
          siteGuid: this.site,
          fromMonth: this.fromMonth.format("MM-YYYY"),
          toMonth: this.toMonth.format("MM-YYYY")
        }
      }

      if(this.maxMonth) {
        this.params.toMonth = this.maxMonth.format("MM-YYYY")
      }

      this.channels = []

      let channels = _.cloneDeep(
        this.userSites.find(s => s.guid == this.site)
          .channels.filter(c => c.data_model_id == 1)
      )

      let vectors = channels.map(c => c.vector)
      this.vectors = [];
      ['EE', 'gas', 'olioc', 'Diesel', 'water', 'fluidth', 'benz', 'GPL'].forEach(v => {
        const vector = vectors.find(_v => _v == v)
        if(vector)
          this.vectors.push(vector)
      })
      _.uniq(vectors).forEach(v => {
        const vector = this.vectors.find(_v => _v == v)
        if(! vector)
          this.vectors.push(vector)
      })
      // this.vectors = _.uniq(vectors)

      this.$store.dispatch('diagnosi/setVectors', this.vectors)

      this.fillChannels(null)

      let categoryParams = _.cloneDeep(this.params)
      //categoryParams.level = "category";

      this.$store.dispatch('charts/tepAll', this.params).then((data) => {
        if(! data.data) {
          this.$notify({
            type: "error",
            text: data.message,
            title: 'Errore',
          });
          return;
        }

        this.tep = data.data;

        const c = this.tep.map(e => {
          return {
            category: e.category,
            categoryId: e.categoryId,
            vector: e.vector
          }
        })

        this.categories = _.filter(_.uniqWith(c, _.isEqual), e => e.categoryId > 0)
        this.loading = false;
        this.stopLoading();
      })
    },

    getTitle(channel) {
      return channel.name + ( channel.mu ? " [" + channel.mu + "]"  : "")
    },

    fillChannels(parentCode) {
      if(! this.site) {
        return
      }

      let site = this.userSites.find(s => s.guid == this.site)

      if(! site) {
        return
      }

      let all = site.channels

      all.forEach(c => {
        if(c.parent_code == parentCode && all.filter(cc => cc.parent_code == c.code).length > 0) {
          this.channels.push(c)
          this.fillChannels(c.code)
        }
      })
    },

    categoriesForVector(vector) {
      return this.categories.filter(c => c.vector == vector)
    },

    vectorName(vector) {
      return this.$store.getters['vectors/getName'](vector)
    },

    getModelloLink(vector) {
      return "modello-" + vector
    },

    getAllocazioneLink(vector) {
      return "allocazione-" + vector
    },
    print() {
      window.print()
    }

  },
  computed: {
    monthLabels() {
      return 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_')
    },
    sites() {
      return this.userSites.map(s => { return { text: s.name, value: s.guid } })
    },
    siteName() {
      if(! this.site)
        return ""
      return _.find(this.userSites, s => s.guid == this.site).name
    },
    fromMonthLabel() {
      return this.fromMonth.format("MM/YYYY")
    },
    toMonthLabel() {
      return this.toMonth.format("MM/YYYY")
    }
  },
  watch: {
    site() {
      this.refresh();
    },
    maxMonth() {
      this.reload();
    },

    fromMonth(prevVal, newVal) {
      if (prevVal.format('DD-MM-YYYY') === newVal.format('DD-MM-YYYY')) {
        return;
      }

      let duration = moment.duration(this.toMonth.diff(this.fromMonth))
      if (duration.asMonths() > 11 || duration.asMonths() < 2) {
        const newToMonth = moment(this.fromMonth).add(11, "months");

        let newMonthDuration = moment.duration(this.maxDate.diff(this.fromMonth));
        this.toMonth = newMonthDuration.asMonths() < 3 ? moment().add(-1, 'months') : newToMonth;
      }

      this.refresh();
    },

    toMonth(prevVal, newVal) {
      if (prevVal.format('DD-MM-YYYY') === newVal.format('DD-MM-YYYY')) {
        return;
      }

      let duration = moment.duration(this.toMonth.diff(this.fromMonth))
      if (duration.asMonths() > 11 || duration.asMonths() < 2) {
        this.fromMonth = moment(this.toMonth).subtract(11, "months");
      }

      this.refresh();
    }
  }
}
</script>

<style>
.sections-jumper {
  padding-left: 10px;
}
.sections-jumper li {
  display: block;
  float: none;
  font-size: 12px;
  margin-bottom: 12px;
}
.sections-jumper li svg {
  position: relative;
  top: -1px;
  margin-right: 4px;
}
.sections-jumper li a {
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Diagnosi/Page.vue